import { HTTP } from '@/http-common'
import { groupBy } from 'lodash'
const state = {
  featured: [],
  products: [],
  categories: [],
  currentRecipes: [],
  favoriteRecipes: null
}
const getters = {
  getCatelog: s => {
    return groupBy(s.products, 'Type')
  },
  categories: s => s.categories,
  uses: s => s.categories.filter(x => x.TopLevel === true),
  currentRecipes: s => s.currentRecipes,
  favoriteRecipes: s => s.favoriteRecipes
}
const actions = {
  async getAllcontent({ dispatch }) {
    dispatch('getFeatured')
    dispatch('getProducts')
    dispatch('getCategories')
    dispatch('getFavorites')
  },
  async getFeatured({ commit }) {
    await HTTP.get('/recipes/featured').then(response => {
      commit('SET_FEATURED', response.data)
    })
  },
  async getProducts({ commit }) {
    await HTTP.get('/oils').then(response => {
      commit('SET_PRODUCTS', response.data)
    })
  },
  async getCategories({ commit }) {
    await HTTP.get('/useCategories').then(response => {
      commit('SET_CATEGORIES', response.data)
    })
  },
  async getFavorites({ commit, getters }) {
    await HTTP.get('/recipes/favorites/' + getters.user.Id).then(response =>
      commit('ADD_FAVORITE_RECIPES', response.data)
    )
  },
  getRecipesForUse({ commit }, useId) {
    commit('SET_CURRENT_RECIPES', [])
    HTTP.get('recipes/use/' + useId).then(response => {
      commit('SET_CURRENT_RECIPES', response.data)
    })
  },
  // likeTestimonial({ commit, getters }, testimonial) {
  //   const testimonialReq = {
  //     UserId: getters.user.Id,
  //     RecipeTestimonialId: testimonial.Id
  //   }
  //   // MongoUserId: ''
  //   console.log(testimonialReq)
  //   HTTP.post('recipes/testimonials/toggleVote', testimonialReq)
  //     .then(response => console.log(response.data))
  //     .catch(error => {
  //       console.log(error)
  //       console.log(error.response)
  //     })
  // },
  updateFavoriteRecipe({ commit, dispatch }, favorite) {
    HTTP.post('users/FavoriteRecipe', favorite).then(response => {
      commit('SET_USER', response.data)
      dispatch('getFavorites')
    })
  }
}
const mutations = {
  SET_FEATURED(s, featured) {
    s.featured = featured
  },
  SET_PRODUCTS(s, products) {
    s.products = products
  },
  SET_CATEGORIES(s, categories) {
    s.categories = categories
      .slice()
      .sort((a, b) => a.Name.localeCompare(b.Name))
  },
  SET_CURRENT_RECIPES(s, recipes) {
    s.currentRecipes = recipes
  },
  ADD_FAVORITE_RECIPES(s, recipes) {
    s.favoriteRecipes = recipes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
